<template>
  <v-app>
    <Navbar />
    <v-main class="grey lighten-5" style="padding: 10px 0px 0px !important;" :class="$vuetify.breakpoint.mdAndUp ? 'mt-15' : ''">
       <BottomNavigation  v-if="!$vuetify.breakpoint.lgAndUp"/>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from './components/NavbarComponent';
import BottomNavigation from './components/BottomNavigation.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    BottomNavigation
  }
};
</script>

<style>
body, .v-application {
  font-family: 'Nunito Sans', sans-serif !important;
}

.v-btn:not(.v-btn--round).v-size--default {
    height: 55px !important;
    min-width: 64px !important;
    padding: 0 16px !important;
}

/* Responsive grid for bottom navigation */
.bottom-nav-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 667px) {
  .bottom-nav-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0;
  }
  .bottom-nav-grid > * {
    min-width: 0 !important;
    width: 100%;
    justify-content: center;
  }
  .v-bottom-navigation {
    height: 58px !important;
    transform: none !important;
  }
}

.theme--dark.v-app-bar.v-toolbar.v-sheet {
    background-color: #7f182f;
}

.theme--dark.v-bottom-navigation {
    background-color: #7f182f;
    color: #FFFFFF;
}

.theme--dark.v-btn.v-btn--has-bg {
    background-color: #7f182f;
}
.active-btn {
    background-color: #641223 !important;
    color: #fff !important;
}

.theme--dark.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: rgba(255, 255, 255, 0.7);
}

</style>
